module.exports = __webpack_public_path__ + "media/images/play-0e7facb4abbb409d5f7cf63b1456da92.png";